<template>
  <section class="chart-filter-panel">
    <template v-for="(button, index) in buttons">
      <BarItem
        v-if="!(button.name === 'time_saved' && !$store.getters.currentFilteringSite.isTimeSave)"
        :key="button.name"
        :isAmended="button.isAmended"
        :trendInfo="button.trendInfo"
        :activeIconUrl="button.activeIconUrl"
        :activeColor="button.color"
        :iconUrl="button.iconUrl"
        :activeStatus="button.isActive"
        :class="{
          last: index === buttons.length - 1,
          first: index === 0
        }"
        :label="$t(button.name)"
        :text="button.text"
        :subText="button.subText"
        :hint="button.hint"
        componentType="chart-filter-button"
        @click="handleFilterClick(index, $event)"
      />
    </template>
  </section>
</template>

<script>
import BarItem from './BarItem'

export default {
  props: {
    /**@type {{ new(): {
     * color: String;
     * iconUrl: String;
     * isActive: Boolean;
     * label: String;
     * name: String;
     * text: String;
     * activeIconUrl?: String;
     * }[] }} */
    buttons: { type: Array, required: true }
  },
  methods: {
    handleFilterClick(index) {
      this.$emit('input', index)
    }
  },
  components: {
    BarItem
  }
}
</script>

<style lang="scss" scoped>
.chart-filter-panel {
  display: flex;
  gap: 12px;
  overflow-x: auto;
  padding-bottom: 4px;
  padding-top: 4px;
  scrollbar-width: thin;
  
  &::-webkit-scrollbar {
    height: 4px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 2px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 2px;
    
    &:hover {
      background: #a8a8a8;
    }
  }
  
  > * {
    flex-shrink: 0;
    min-width: 200px;
  }

  @media (max-width: 768px) {
    // Keep horizontal layout on mobile too
    > * {
      min-width: 150px;
    }
  }
}
</style>